
import { defineComponent, computed, watch} from "vue";
import { useStore } from "@/store";
import mixin from "@/mixin";

export default defineComponent({
  props: {
    total: {
      type: Number,
      default: 0,
    },
    paymentCurrencyId: {
      type: Number,
      default: 0,
    },
  },
  async setup(props) {
    const store = useStore();
    const localCurrencyId = computed(() => store.state.localCurrencyId);
    const orderCurrencyId = computed(() => store.state.order.currencyId);
    function getCurrencySign(id: number) {
      return store.state.currencies.find((x) => x.id == id)?.symbol ?? "";
    }
    function getCurrencyRate(id: number) {
      return (
        store.state.currencyRates.find((x) => x.currencyId == id)?.rate ?? 1
      );
    }

    return {
      localCurrencyId,
      orderCurrencyId,
      getCurrencySign,
      getCurrencyRate,
    };
  },
});
